import React from "react";


const Button = ({
  icon,
  color,
  label,
  handleButton,
  disabled = false,
  dataTip = ""
}) => {
  const button = (
    <button
      className={`btn--dropdown-form btn btn--${color} btn--icon`}
      disabled={disabled}
      onClick={() => {
        if (!disabled) {
          handleButton(label);
        }
      }}
    >
      <i className={`btn--dropdown-form ${icon} btn--icon`}></i>
      {label}
    </button>
  );

  return (
    <div className="btn--dropdown-wrapper">
      <div>
        {disabled && dataTip ? (
          <span data-tip={dataTip}>{button}</span>
        ) : (
          button
        )}
      </div>
    </div>
  );
};

export default Button;